export default "__VITE_ASSET__CSTRU3Ye__"